import { ReactNode } from 'react';

import { GradientHeaderStyles } from './GradientHeader.styles';

export const GradientHeader = ({ children }: { children?: ReactNode }) => (
  <GradientHeaderStyles>{children}</GradientHeaderStyles>
);
